import { api, catchErrorHandler } from "utils/api";

export const updateMainCenter = async ({ seqPartner, seqPartnerBranch }) => {
  try {
    await api.patch(`/interlock/main`, {
      seqPartner,
      seqPartnerBranch,
    });
    return;
  } catch (error) {
    return catchErrorHandler(error, "updateMainCenter");
  }
};
